import { render, staticRenderFns } from "./PT508GTMViewListItem.vue?vue&type=template&id=8ddfc7ae&"
import script from "./PT508GTMViewListItem.vue?vue&type=script&lang=js&"
export * from "./PT508GTMViewListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports